import { useRef, useEffect } from 'react';

function usePreviousValue<T>(value: T) {
  const ref = useRef(value);

  // store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // only re-run if value changes

  // return previous value (happens before update in useEffect above)
  return ref.current;
}

export { usePreviousValue };
